export default {
  slogan: 'Playturbo',
  loginToPt: 'Login to Playturbo.',
  loginPopbox: {
    title: 'Tip',
    content: 'Login failed. Please try again',
    confirm: 'Confirm',
  },
  form: {
    userPlaceHolder: 'Username',
    userRequiredText: 'The username or email cannot be empty',
    passwordPlaceHolder: 'Password',
    passwordRequiredText: 'The password cannot be empty',
    verifyCodeRequiredText: 'The verification code cannot be empty',
    loginText: 'Login',
    loginSuccessText: 'Login successfully！',
    forgetText: 'Forgot password',
    registerText: 'Sign Up for Free',
    privacyLabel: {
      readAgreed: 'I have read, understood and agreed to the',
      userAgreement: 'Terms of Service',
      membershipAgreement: 'Playturbo Membership Service Agreement',
      and: 'and',
      privacyAgreement: 'Privacy Policy',
      dpaTitle: '“Data Protection Appendix”',
      dpaDesc:
        'I confirm that I have obtained all necessary rights or permissions to upload these voice samples and guarantee not to use platform-generated content for any illegal, fraudulent, or harmful purposes.',
    },
    privacyRequiredText: 'Please check the confidentiality agreement.',
  },
  swiper: {
    psTitle: 'Playable Tools, easy to use with zero threshold',
    videoTitle: 'Video Tools, batch creation of works',
    recordTitle: 'Screen Recording Tool, freeing your hands',
    psLabel:
      'Create playable ads without code.<br/>One-click advertising in multiple languages and channels.<br/>High-quality template selection breaks down barriers.',
    videoLabel:
      'Massive commercial asset library, satisfying all effects.<br/>Batch variation and one-click output of multiple works.<br/>Intelligent dubbing, subtitle adaptation, edit in one stop.',
    recordLabel:
      'Customizable parameter settings,matching level content as you like.<br/>Easily output multiple versions in one recording operation.',
  },
  about: 'About ',
  register: 'Sign Up',
}
